import { ColumnItemAlignment } from '../types/columnItemAlignment'

export const alignmentToJustifyContent: Record<ColumnItemAlignment, string> = {
  left: 'flex-start',
  right: 'flex-end',
}
